// dependencies
import React from "react";
import { z } from "zod";

// components
import { FormCheckboxGroup, FormRadioButtons, PanelFilters } from "@performyard/py-components";

import { Option } from "../../../../../../../components/Inputs/SelectionOptions/RadioButtons";

const StatusSelectionOptions: Option[] = [
	{
		label: "Any Status",
		value: "",
	},
	{
		label: "Active",
		value: "Active",
	},
	{
		label: "Completed",
		value: "Completed",
	},
	{
		label: "Scheduled",
		value: "Scheduled",
	},
];

export const Reviews360Options: Option[] = [
	{
		label: "360 Enabled",
		value: "easyAddEnabled",
	},
];

export const AutomationStatusSelectionOptions: Option[] = [
	{
		label: "All Reviews",
		value: "",
	},
	{
		label: "Automated Review Cycles",
		value: "automated",
	},
	{
		label: "Non-Automated Review Cycles",
		value: "non-automated",
	},
];

const ReviewCycleFilterSchema = z.object({
	automation_status: z.enum(["automated", "non-automated", ""]).optional(),
	status: z.string().optional(),
	reviews360: z.array(z.string()).optional(),
});

export type ReviewCycleFilter = z.infer<typeof ReviewCycleFilterSchema>;

interface ReviewCyclesFiltersProps {
	isOpen: boolean;
	onClose: () => void;
	filters: ReviewCycleFilter;
	onApplyFilters: (filters: ReviewCycleFilter) => void;
	automationEnabled: boolean;
}

const ReviewCyclesFilters = ({
	isOpen,
	onClose,
	filters,
	onApplyFilters,
	automationEnabled,
}: ReviewCyclesFiltersProps) => {
	const defaultValues: ReviewCycleFilter = {
		automation_status: filters?.automation_status || "",
		status: filters?.status || "",
		reviews360: filters?.reviews360 || [],
	};

	const handleApplyFilters = ({
		value,
	}: {
		value: Partial<ReviewCycleFilter>;
		resetForm: () => void;
		setError: (field: keyof ReviewCycleFilter, error: string) => void;
	}) => {
		const formattedState = { ...value };
		Object.keys(formattedState).forEach((key) => {
			const filterValue = formattedState[key as keyof ReviewCycleFilter];
			if (
				filterValue === null ||
				filterValue === undefined ||
				filterValue === "" ||
				(Array.isArray(filterValue) && filterValue.length === 0)
			) {
				delete formattedState[key as keyof ReviewCycleFilter];
			}
		});

		onApplyFilters(formattedState);
		onClose();
	};

	return (
		<PanelFilters
			isOpen={isOpen}
			onClose={onClose}
			schema={ReviewCycleFilterSchema}
			defaultValues={defaultValues}
			onSubmit={handleApplyFilters}
		>
			<div className="space-y-4">
				{automationEnabled && (
					<FormRadioButtons
						id="automation_status"
						label="Review Cycle Type"
						options={AutomationStatusSelectionOptions}
					/>
				)}
				<FormRadioButtons id="status" label="Status" options={StatusSelectionOptions} />
				<FormCheckboxGroup id="reviews360" label="360 Reviews" options={Reviews360Options} />
			</div>
		</PanelFilters>
	);
};

export default ReviewCyclesFilters;
